const auditLogger = {
  logAction: (action, details) => {
    const logEntry = {
      timestamp: new Date().toISOString(),
      action,
      details,
      user: JSON.parse(localStorage.getItem("user") || "{}")?.email || "unknown",
    };

    // Store in localStorage for demo purposes
    const existingLogs = JSON.parse(localStorage.getItem("auditLogs") || "[]");
    existingLogs.push(logEntry);
    localStorage.setItem("auditLogs", JSON.stringify(existingLogs.slice(-100))); // Keep last 100 logs

    // In production, send to API
    // axios.post(`${ApiName}/Audit`, logEntry, {
    //   headers: { Authorization: localStorage.authToken }
    // });

    console.log("Audit Log:", logEntry);
  },

  getLogs: () => {
    return JSON.parse(localStorage.getItem("auditLogs") || "[]");
  },

  clearLogs: () => {
    localStorage.removeItem("auditLogs");
  },
};

export default auditLogger;
